import React, { useState } from 'react';
import { usePlaces } from '../context/PlaceContext';
import SearchBar from './SearchBar';

const SecondaryPlaceAdder = () => {
  const { handlePlaceSelected } = usePlaces();
  const [searchInput, setSearchInput] = useState('');
  const [unsupportedWarning, setUnsupportedWarning] = useState(false);

  const onPlaceSelectedFromSearch = async (placeDetails) => {
    setSearchInput('');
    setUnsupportedWarning(false);

    try {
      // Call handlePlaceSelected with isPrimary=false
      const updated = await handlePlaceSelected(placeDetails, false);

      // If the newly saved place has null metro_area, show a banner
      if (updated && updated.metro_area === null) {
        setUnsupportedWarning(true);
      }
    } catch (err) {
      console.error('[SecondaryPlaceAdder] onPlaceSelectedFromSearch error:', err.message);
    }
  };

  return (
    <div>
      <h3>Know another place just like this? Add it:</h3>

      {unsupportedWarning && (
        <div style={{ backgroundColor: 'pink', padding: '1rem', margin: '1rem 0' }}>
          <strong>sorry!</strong>
          <p>
          we don't support this place's metro area yet. some features might be unavilable for this place, for now.
          </p>
        </div>
      )}

      <SearchBar
        onPlaceSelected={onPlaceSelectedFromSearch}
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        placeholder="Search for a place"
      />
    </div>
  );
};

export default SecondaryPlaceAdder;